import React from 'react';
import { useDispatch } from 'react-redux';
import { TextField } from '@mui/material';
import { handleJobFilters } from '../../store/reducer/commonSlice';
import './inputField.css';

const InputField = ({ label, value }) => {
  const dispatch = useDispatch();
  return (
    <div className='input'>
      <TextField
        size='small'
        label={label}
        value={value}
        id="outlined-basic"
        variant="outlined"
        onChange={(e) => dispatch(handleJobFilters({
          key: label,
          value: e.target.value
        }))}
      />
    </div>
  )
}

export default InputField;
